<template>
  <div class="vff-animate q-form f-fade-in-up">
    <div class="q-inner">
      <div v-if="translatedQuestions.length > 0">
        <div class="fh2">
          <div class="f-answer f-full-width">
            <CustomRadioList
              :options="radioListOptions"
              layout="vertical"
              label-align="start"
              @option-selected="handleQuestionSelected"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        class="unavailable-selection-notification unavailable-selection-notification--adviser"
      >
        <div class="unavailable-selection-notification__icon">
          <AppIcon icon="warning" />
        </div>
        <div class="unavailable-selection-notification__text text-lg-nowrap">
          <p class="my-3 fs-5" v-html="$t('kb.no_questions')"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { router } from '@inertiajs/vue3'
import { KbQAData, KbLocalization } from '~types/concierge'
import { getActiveLanguage } from 'laravel-vue-i18n'
import CustomRadioList, {
  RadioListOption
} from '~conciergeUiCommons/components/CustomRadioList.vue'

export default defineComponent({
  name: 'KbQuestions',
  components: { CustomRadioList },
  props: {
    questions: {
      type: Array as PropType<KbQAData[]>,
      required: true
    },
    lang: {
      type: String as PropType<string>,
      default: getActiveLanguage()
    }
  },
  computed: {
    translatedQuestions(): KbQAData[] {
      return this.questions
        .filter(question => {
          return (
            question.question[this.lang as keyof KbLocalization] !== '' &&
            question.question[this.lang as keyof KbLocalization] !== null
          )
        })
        .map(question => {
          return {
            ...question,
            question: question.question[this.lang as keyof KbLocalization]
          }
        })
    },
    radioListOptions(): RadioListOption[] {
      return this.translatedQuestions.map(question => ({
        label: question.question,
        value: question
      }))
    }
  },
  methods: {
    goToQuestions(service: KbQAData): void {
      if (this.hasAnswer(service)) {
        return router.visit(this.getAnswerLink(service))
      }
    },
    handleQuestionSelected(value: any, option: RadioListOption) {
      const question = this.translatedQuestions.find(q => q.question === option.label)
      if (question) {
        this.goToQuestions(question)
      }
    },
    getAnswerLink(service: KbQAData): string {
      return this.hasAnswer(service)
        ? service.endpoints.answer[this.lang as keyof KbLocalization]
        : ''
    },
    hasAnswer(service: KbQAData): boolean {
      return (
        Object.hasOwn(service.endpoints, 'answer') &&
        service.endpoints.answer[this.lang as keyof KbLocalization] !== '' &&
        service.endpoints.answer[this.lang as keyof KbLocalization] !== null
      )
    }
  }
})
</script>
